import { scaleOrdinal } from 'd3-scale'

export const minFontSize = 10
export const maxFontSize = 50

export const unselectedFill = scaleOrdinal([
	'#1f77b4',
	'#ff7f0e',
	'#2ca02c',
	'#d62728',
	'#9467bd',
	'#8c564b',
	'#e377c2',
	'#7f7f7f',
	'#bcbd22',
	'#17becf',
])
export const selectedFill = scaleOrdinal(
	['selected', 'notSelected'],
	['#1f77b4', '#C0C0C0']
)
